import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import StandardButton from '../StandardButton';
import Text from '../Text'; // TODO: rework this to use Text component
import { useAppSelector } from '../../app/hooks';
import getDeviceTypeMobile from '../../selectors/getDeviceTypeMobile';
import { MOBILE_MODAL_TYPES } from '../../constants';

interface MessageModalProps {
  title?: string;
  message?: string;
  titleStyle?: React.CSSProperties;
  desktopMaxWidth?: number;
  desktopWidth?: number;
  handleClose: () => void;
  hideCloseButton?: boolean;
  buttonText?: string;
  action?: () => void;
  alertButtons?: AlertButton[];
}

/**
 * Purely presentational message modal, driven entirely by props - no coupling to the
 * shared `modalParams`/`currentModalId` redux slot. Use this directly (rather than
 * `modals/MessageModal`) for a modal shown via its own standalone open/close state.
 */
const MessageModal = ({
  title,
  message,
  titleStyle,
  desktopMaxWidth = 500,
  desktopWidth = 500,
  handleClose,
  hideCloseButton,
  buttonText,
  action,
  alertButtons,
}: MessageModalProps) => {
  const { t } = useTranslation();
  const deviceTypeMobile = useAppSelector(getDeviceTypeMobile);

  return (
    <Modal
      title={title}
      desktopMaxWidth={desktopMaxWidth}
      desktopWidth={desktopWidth}
      desktopContainerStyle={styles.modalDesktopContainer}
      titleStyle={titleStyle}
      handleClose={handleClose}
      wrapperStyle={deviceTypeMobile ? styles.wrapperStyleMobile : styles.wrapperStyleDesktop}
      mobileContainerStyle={styles.mobileContainerStyle}
      mobileModalType={MOBILE_MODAL_TYPES.ALERT}
      closeButtonLeft={true}
      enableCloseButton={!hideCloseButton}
    >
      {message && <Text block value={message} themeKey="messageModalMessage" />}

      <div style={styles.buttonStack}>
        {alertButtons && alertButtons.length > 0 ? (
          alertButtons.map(button => (
            <StandardButton
              label={button.text ?? t('button.ok')}
              onClick={button.action ?? handleClose}
              themeKey={button.isPreferred ? 'messageModalButton' : 'messageModalBorderButton'}
              disabled={button.disabled}
            />
          ))
        ) : (
          <StandardButton
            label={buttonText ?? t('button.ok')}
            onClick={action ?? handleClose}
            themeKey="messageModalButton"
          />
        )}
      </div>
    </Modal>
  );
};

const styles: Styles = {
  modalDesktopContainer: {
    gap: 50,
    paddingBottom: 40,
  },
  wrapperStyleDesktop: {
    justifyContent: 'center',
  },
  wrapperStyleMobile: {},
  mobileContainerStyle: {
    paddingTop: 60,
    height: '100%',
    gap: 30,
  },
  buttonStack: {
    gap: 10,
    display: 'flex',
    flexDirection: 'column',
  },
};

export default MessageModal;
